import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalPhieuThu } from "./ModalPhieuThu";
import { ModalPhieuChi } from "./ModalPhieuChi";

export const BtnInPhieuThuChi = ({
  item,
  inthuchi,
  inPhieuChi,
  inPhieuThu,
}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Value > 0 là phiếu thu, còn lại là phiếu chi — cùng điều kiện chọn modal bên dưới
  const coQuyenIn = item.Value > 0 ? inPhieuThu : inPhieuChi;
  if (!coQuyenIn) return null;

  return (
    <>
      <a href={() => false} onClick={handleShow}>
        <PopoversBootrap
          contentText="In phiếu"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
         <img src="/app-assets/images/icon-in-danh-sach.png" />
        </PopoversBootrap>
      </a>
      {item.Value > 0
        ? show && (
            <ModalPhieuThu
              show={show}
              onHide={handleClose}
              id={item.ThuChiID}
              CVType={item.CVType}
              inthuchi={inthuchi}
              inPhieuThu={inPhieuThu}
            />
          )
        : show && (
            <ModalPhieuChi
              show={show}
              onHide={handleClose}
              id={item.ThuChiID}
              hopdongId={item.ChoVayID}
              CVType={item.CVType}
              inthuchi={inthuchi}
              inPhieuChi={inPhieuChi}
            />
          )}
    </>
  );
};
